/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorCodesModel,
  SocialCallbackModel,
} from '../models/index';
import {
    ErrorCodesModelFromJSON,
    ErrorCodesModelToJSON,
    SocialCallbackModelFromJSON,
    SocialCallbackModelToJSON,
} from '../models/index';

export interface SocialLoginCallbackRequest {
    userAgent: string;
    code?: string;
    secret?: string;
    type?: string;
    id?: string;
    username?: string;
    email?: string;
    originDomain?: string;
}

/**
 * 
 */
export class ConnectApi extends runtime.BaseAPI {

    /**
     * googleやX連携ログインの際のコールバック用API 初回連携時には会員登録用の連携情報を返却します 連携済の場合はコミチ側の認証処理を行い、トークンを返却します 認証成功時は以下の処理が行われます   * GA4のuser_pseudo_id (デバイス固有のID) とUAの保存   * サイト単位のログイン履歴保存   * 規約同意チェック   * 復帰ユーザーミッション達成判定 (ミッション達成時のみミッション情報をレスポンスで返却)
     * ソーシャルログイン認証
     */
    async socialLoginCallbackRaw(requestParameters: SocialLoginCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SocialCallbackModel>> {
        if (requestParameters.userAgent === null || requestParameters.userAgent === undefined) {
            throw new runtime.RequiredError('userAgent','Required parameter requestParameters.userAgent was null or undefined when calling socialLoginCallback.');
        }

        const queryParameters: any = {};

        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }

        if (requestParameters.secret !== undefined) {
            queryParameters['secret'] = requestParameters.secret;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.username !== undefined) {
            queryParameters['username'] = requestParameters.username;
        }

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        if (requestParameters.originDomain !== undefined) {
            queryParameters['originDomain'] = requestParameters.originDomain;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.userAgent !== undefined && requestParameters.userAgent !== null) {
            headerParameters['User-Agent'] = String(requestParameters.userAgent);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/connect/social/callback`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SocialCallbackModelFromJSON(jsonValue));
    }

    /**
     * googleやX連携ログインの際のコールバック用API 初回連携時には会員登録用の連携情報を返却します 連携済の場合はコミチ側の認証処理を行い、トークンを返却します 認証成功時は以下の処理が行われます   * GA4のuser_pseudo_id (デバイス固有のID) とUAの保存   * サイト単位のログイン履歴保存   * 規約同意チェック   * 復帰ユーザーミッション達成判定 (ミッション達成時のみミッション情報をレスポンスで返却)
     * ソーシャルログイン認証
     */
    async socialLoginCallback(requestParameters: SocialLoginCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SocialCallbackModel> {
        const response = await this.socialLoginCallbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
